export const joinWaitlist = async (body) => {
  const apiendpoint = process.env.PROD_API_URL;
  const url = `${apiendpoint}waitlist/join`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: body.email, waitlistId: body.waitlistId }),
    });

    return await response.json();
  } catch (error) {
    return error;
  }
};
